/* GA4, Meta Pixel e TikTok Pixel. IDs vêm de window.nfrAnalyticsIds (snippets/nfr-analytics.liquid).
   Só carrega depois do consentimento: localStorage nfr_consent = 'all' ou evento nfr:consent. */
(function () {
  var ids = window.nfrAnalyticsIds || {};
  var ok = {
    ga4: /^G-[A-Z0-9]{4,20}$/.test(ids.ga4),
    meta: /^[0-9]{5,20}$/.test(ids.meta),
    tiktok: /^[A-Z0-9]{8,30}$/.test(ids.tiktok)
  };
  var started = false;

  function start() {
    if (started) return;
    started = true;

    if (ok.ga4) {
      var g = document.createElement('script');
      g.async = true;
      g.src = 'https://www.googletagmanager.com/gtag/js?id=' + ids.ga4;
      document.head.appendChild(g);
      window.dataLayer = window.dataLayer || [];
      window.gtag = function () { window.dataLayer.push(arguments); };
      window.gtag('js', new Date());
      window.gtag('config', ids.ga4);
    }

    if (ok.meta) {
      !function(f,b,e,v,n,t,s){if(f.fbq)return;n=f.fbq=function(){n.callMethod?n.callMethod.apply(n,arguments):n.queue.push(arguments)};if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';n.queue=[];t=b.createElement(e);t.async=!0;t.src=v;s=b.getElementsByTagName(e)[0];s.parentNode.insertBefore(t,s)}(window,document,'script','https://connect.facebook.net/en_US/fbevents.js');
      window.fbq('init', ids.meta);
      window.fbq('track', 'PageView');
    }

    if (ok.tiktok) {
      !function(w,d,t){w.TiktokAnalyticsObject=t;var ttq=w[t]=w[t]||[];ttq.methods=["page","track","identify","instances","debug","on","off","once","ready","alias","group","enableCookie","disableCookie","holdConsent","revokeConsent","grantConsent"],ttq.setAndDefer=function(t,e){t[e]=function(){t.push([e].concat(Array.prototype.slice.call(arguments,0)))}};for(var i=0;i<ttq.methods.length;i++)ttq.setAndDefer(ttq,ttq.methods[i]);ttq.instance=function(t){for(var e=ttq._i[t]||[],n=0;n<ttq.methods.length;n++)ttq.setAndDefer(e,ttq.methods[n]);return e},ttq.load=function(e,n){var r="https://analytics.tiktok.com/i18n/pixel/events.js",o=n&&n.partner;ttq._i=ttq._i||{},ttq._i[e]=[],ttq._i[e]._u=r,ttq._t=ttq._t||{},ttq._t[e]=+new Date,ttq._o=ttq._o||{},ttq._o[e]=n||{};n=document.createElement("script");n.type="text/javascript",n.async=!0,n.src=r+"?sdkid="+e+"&lib="+t;e=document.getElementsByTagName("script")[0];e.parentNode.insertBefore(n,e)};ttq.load(ids.tiktok);ttq.page();}(window,document,'ttq');
    }
  }

  function granted() {
    try { return localStorage.getItem('nfr_consent') === 'all'; } catch (e) { return false; }
  }

  if (granted()) start();
  document.addEventListener('nfr:consent', function (e) {
    if (e.detail && e.detail.all) start();
  });
})();
